<template>
    <v-container fluid>
        <v-row
            align="center"
            justify="center"
            class="mx-0"
        >
            <v-col cols="12">
                <v-breadcrumbs :items="breadcrumbItems" large></v-breadcrumbs>
            </v-col>
        </v-row>
        <v-row
             align="center"
            justify="center"
            class="mx-0"
        >
            <v-col cols="12">
            <v-card>
                <v-card-title class="text-h5 pb-0 mb-1">
                   <v-row justify="center" align="center">
                       <v-col>
                           Manage your Premiere Business Profile
                        </v-col>
                       <v-col>
                           <p class="pa-0 ma-0 text-right">
                                <v-btn outlined depressed color="secondary" @click="onSave" large>Save Changes</v-btn>
                           </p>
                       </v-col>
                   </v-row>
                </v-card-title>
                <v-card-text>
                    <v-form
                        ref="form"
                        v-model="valid"
                    >
                    <v-row justify="space-between">
                        <v-col cols=12 xs=12 md=8 lg=6 xl=5>
                            <div class="text-h5  mb-4">Your Profile</div>
                            <div class="text-subtitle-1 font-weight-medium mb-3">General Details</div>
                            <v-text-field
                                dense
                                label="Business Name"
                                prepend-inner-icon="work"
                                outlined
                                v-model="name"
                                :rules="nameRules"
                                :validate-on-blur="isFirstSubmissionAttempt"
                            ></v-text-field>
                            <v-row>
                                <v-col cols="4" class="my-0 py-0">
                                    <v-autocomplete
                                        v-model="selectedTelephoneCode" 
                                        label="Country" 
                                        required outlined 
                                        dense
                                        :items="telephoneCodes"
                                        item-text="number"
                                        item-value="countryCode"
                                        return-object
                                        :filter="filterTelephoneCodeAutocompleteBox"
                                    >
                                        <template slot="item" slot-scope="data">
                                        {{ data.item.number }} ({{ data.item.name }})
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="8" class="my-0 py-0">
                                    <v-text-field
                                        dense
                                        label="General Phone Number"
                                        prepend-inner-icon="phone"
                                        outlined
                                        v-model="phoneNumber"
                                        :rules="phoneNumberRules"
                                        :validate-on-blur="isFirstSubmissionAttempt"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-text-field
                                dense
                                label="General Contact Email"
                                prepend-inner-icon="alternate_email"
                                outlined
                                v-model="contactEmail"
                                :rules="emailRules"
                                :validate-on-blur="isFirstSubmissionAttempt"
                            ></v-text-field>
                            <v-text-field
                            dense
                            label="Website"
                            placeholder=" "
                            prefix="https://"
                            prepend-inner-icon="web"
                            outlined
                            v-model="website"
                            ></v-text-field>
                            <div class="text-subtitle-1 font-weight-medium mb-3">Main Business Address</div>
                            <v-text-field
                            dense
                            label="Address Line 1"
                            prepend-inner-icon="my_location"
                            outlined
                            v-model="address_line_1"
                            ></v-text-field>

                            <v-text-field
                            dense
                            label="Address Line 2"
                            prepend-inner-icon="traffic"
                            outlined
                            v-model="address_line_2"
                            ></v-text-field>
                            <v-row class="my-0 py-0"> 
                            <v-col cols=6 class="my-0 py-0">
                                <v-text-field
                                label="Town/ City"
                                dense
                                prepend-inner-icon="location_city"
                                outlined
                                v-model="address_city"
                                ></v-text-field>
                            </v-col>
                            <v-col cols=6 class="my-0 py-0">
                                <v-text-field
                                label="State"
                                dense
                                prepend-inner-icon="map"
                                outlined
                                v-model="address_state"
                                ></v-text-field>
                            </v-col>
                            </v-row>
                            <v-row class="my-0 py-0">
                                <v-col cols=6 class="my-0 py-0">
                                    <v-autocomplete
                                        label="Country"
                                        dense
                                        outlined
                                        v-model="address_country"
                                        :items="countryList"
                                        placeholder="Select..."
                                        required
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols=6 class="my-0 py-0">
                                    <v-text-field
                                    label="Postcode"
                                    dense
                                    prepend-inner-icon="instagram"
                                    outlined
                                    v-model="address_postcode"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-textarea
                                outlined
                                name="input-7-4"
                                label="Add a Bio"
                                counter="500"
                                v-model="bio"
                                rows="10"
                            ></v-textarea>
                        </v-col>
                        <!-- <v-divider vertical class="mx-4 mt-16 mb-10 d-none d-lg-flex"></v-divider> -->
                        <v-col cols=12 xs=12 md=8 lg=6 xl=5>
                            <div class="text-h5 mb-5">Your Branding</div>
                            <v-row class="ma-0 pa-0">
                                <v-col class="ma-0 pa-0">
                                    <v-card class="backgroundImage" :style="`background-color:${ background_color };background-image:url('${ background_image_url }');`">
                                        <v-responsive :aspect-ratio="294/131">
                                        </v-responsive>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-row class="ma-0 pa-0 display-image-offset">
                                <v-col cols=2 class="ma-0 pa-0">
                                </v-col>
                                <v-col class="ma-0 pa-0">
                                    <v-card class="backgroundImage rounded-circle" :style="`background-image:url('${ logo_image_url }');`">
                                        <v-responsive :aspect-ratio="5/5">
                                        </v-responsive>
                                    </v-card>
                                </v-col>
                                <v-col cols=6 class="ma-0 pa-0">
                                </v-col>
                            </v-row>
                            <div class="display-image-offset mt-5">
                            <p class="text-subtitle-1 font-weight-medium mb-2">Customize your Profile Photo or Logo</p>
                            <vue-dropzone 
                                ref="logoImageDropzone" 
                                id="logoImageDropzone" 
                                :options="dropzoneOptions" 
                                @vdropzone-success="logoImageAfterComplete" 
                                @vdropzone-drop="$refs.logoImageDropzone.removeAllFiles()"
                                :useCustomSlot=true
                            >
                                <v-icon x-large color="primary">backup</v-icon>
                                <div class="dropzone-custom-content">
                                <p class="text-h6 primary--text">Drag and drop to upload an image!</p>
                                <div class="text-subtitle1 primary--text">...or click to select an image from your computer</div>
                                </div>
                            </vue-dropzone>
                            <v-btn text color="primary" v-if="logo_image_url!=''" @click="logo_image_url=''">Remove Logo</v-btn>

                            <p class="text-subtitle-1 font-weight-medium mb-2 mt-5">Customize your Cover image</p>
                            <p class="text-subtitle-1 mb-2">Add a solid color</p>
                            <v-menu 
                                offset-y
                                transition="slide-y-transition"
                                :close-on-content-click="false"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn :color="getTextColor(background_color)" width="120" height="100" class="py-10 px-2" dark :style="'background-color:' + background_color + ';'" v-bind="attrs" v-on="on"><v-icon large>palette</v-icon> {{background_color}}</v-btn>
                                </template>
                                <v-color-picker mode="hexa" v-model="background_color"></v-color-picker>
                            </v-menu>
                            <p class="text-subtitle-1 mt-5 mb-2">Or upload a branded image</p>
                            <vue-dropzone 
                                ref="backgroundImageDropzone" 
                                id="backgroundImageDropzone" 
                                :options="dropzoneOptions" 
                                @vdropzone-success="backgroundImageAfterComplete" 
                                @vdropzone-drop="$refs.backgroundImageDropzone.removeAllFiles()"
                                :useCustomSlot=true
                            >
                                <v-icon x-large color="primary">backup</v-icon>
                                <div class="dropzone-custom-content">
                                <p class="text-h6 primary--text">Drag and drop to upload an image!</p>
                                <div class="text-subtitle1 primary--text">...or click to select an image from your computer</div>
                                </div>
                            </vue-dropzone>
                            <v-btn text color="primary" v-if="background_image_url!=''" @click="background_image_url=''">Remove Background Image</v-btn>
                            </div>






















                        </v-col>
                    </v-row>
                </v-form>
                </v-card-text>
            </v-card>
            </v-col>
        </v-row>
        <v-snackbar
            v-model="snackbar"
            left
            multi-line
            :timeout="snackbarTimeout"
        >
            {{ snackbarText }}

            <template v-slot:action="{ attrs }">
            <v-btn
                color="primary"
                text
                v-bind="attrs"
                @click="snackbar = false"
                top
            >
                Close
            </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {getDownloadUrlForRef, getStorageRef, uploadFileInStorage} from "@/shared/firebase_utils";

export default {
    name: 'ManagePremiereProfile',
    components: {
      vueDropzone: vue2Dropzone
    },
    data() {
        return {
            bio: '',
            logo_image_url: '',
            background_color: '',
            background_image_url: '',
            dropzoneOptions: {
                url: 'https://httpbin.org/post',
                thumbnailWidth: 110,
                thumbnailHeight: 110,
                addRemoveLinks: false,
                acceptedFiles: '.jpg, .jpeg, .png',
            },
            isFirstSubmissionAttempt: true,
            valid: false,
            emailRules: [
                v => !!v || 'This field is required',
                v => /.+@.+\..+/.test(v) || 'Invalid email',
            ],
            nameRules: [
                v => !!v || 'This field is required',
            ],
            phoneNumberRules: [
                v => !!v || 'This field is required',
                v => /^\d+$/.test(v)||'Invalid mobile number'
            ],
            snackbar: false,
            snackbarText: '',
            snackbarTimeout: 5000,
            selectedTelephoneCode: {countryCode: 'AU', number: '+61'},
            breadcrumbItems: [
                {
                    text: 'Home',
                    disabled: false,
                    to: '/',
                },
                {
                    text: 'Pappyon Premiere',
                    disabled: false,
                    to: '/pappyonPremiere',
                },
                {
                    text: 'Business Profile',
                    disabled: true,
                },
            ],
             name: '',
            phoneNumber: '',
            contactEmail: '',
            website: '',
            address_line_1: '',
            address_line_2: '',
            address_city: '',
            address_state: '',
            address_country: '',
            address_postcode: '',
        };
    },
    computed: mapGetters(['businessProfile', 'telephoneCodes', 'countryList','userProfile']),
     mounted() {
        this.initEditor();
    },
     methods: {
        ...mapActions(['updateBusinessProfileDetails']),
        async logoImageAfterComplete(file) {
            try {
            //Get a unique file name and set the meta data for the file
            const metaData = {
                contentType: 'image/png'
            };
            
            //Get a firebase storage reference
            const imageRef = getStorageRef(`premiereProfileLogos/${ this.userProfile.businessProfileId }.png`)
            await uploadFileInStorage(imageRef, file, metaData);
            const downloadURL = await getDownloadUrlForRef(imageRef);
            this.logo_image_url = downloadURL;
            //this.images.push({src: downloadURL});
            this.$refs.logoImageDropzone.removeAllFiles();
            } catch (error) {
            console.log("Error while uploading an image");
            console.log(error)
            }
        },

        async backgroundImageAfterComplete(file) {
            try {
            //Get a unique file name and set the meta data for the file
            const metaData = {
                contentType: 'image/png'
            };
            
            //Get a firebase storage reference

            const imageRef = getStorageRef(`premiereProfileCover/${ this.userProfile.businessProfileId }.png`);
            await uploadFileInStorage(imageRef, file, metaData);
            const downloadURL = await getDownloadUrlForRef(imageRef);
            this.background_image_url = downloadURL;
            this.$refs.backgroundImageDropzone.removeAllFiles();
            } catch (error) {
            console.log("Error while uploading the reverse image");
            console.log(error)
            }
        },
        getTextColor(hexcolor) {
            hexcolor = hexcolor.replace("#", "");
            var r = parseInt(hexcolor.substr(0,2),16);
            var g = parseInt(hexcolor.substr(2,2),16);
            var b = parseInt(hexcolor.substr(4,2),16);
            var yiq = ((r*299)+(g*587)+(b*114))/1000;
            return (yiq >= 128) ? 'grey--text text--darken-2' : 'white--text';
        },
        filterTelephoneCodeAutocompleteBox(item, queryText, itemText) {
            if(item.name.toUpperCase().includes(queryText.toUpperCase()) || itemText.toUpperCase().includes(queryText.toUpperCase()))
                return true;
            else
                return false;
        },
        initEditor() {
            this.name = this.businessProfile.businessName || '';
            this.selectedTelephoneCode = {countryCode: this.businessProfile.countryPhoneCode, number: this.businessProfile.countryPhoneCodeNumber};
            this.phoneNumber = this.businessProfile.generalPhoneNumber || '';
            this.contactEmail = this.businessProfile.generalContactEmail || '';
            this.website = this.businessProfile.websiteURL || '';

            this.address_line_1 = this.businessProfile.addressLine1 || '';
            this.address_line_2 = this.businessProfile.addressLine2 || '';
            this.address_city = this.businessProfile.city || '';
            this.address_state = this.businessProfile.state || '';
            this.address_country = this.businessProfile.country || '';
            this.address_postcode = this.businessProfile.postcode || '';

            this.background_image_url = this.businessProfile.premiereProfileBackgroundImageURL || '';
            this.logo_image_url = this.businessProfile.premiereProfileLogoImageURL || '';
            this.bio = this.businessProfile.premiereProfileBio || '';
        },

        async onSave() {
            this.isFirstSubmissionAttempt = false;
            if (this.$refs.form.validate()) {
                this.snackbarText = "Saving changes...";
                this.snackbarTimeout = -1;
                this.snackbar = true;
                try {
                    await this.updateBusinessProfileDetails({
                        businessName: this.name,
                        generalPhoneNumber: this.phoneNumber,
                        generalContactEmail: this.contactEmail,
                        websiteURL: this.website,
                        addressLine1: this.address_line_1,
                        addressLine2: this.address_line_2,
                        city: this.address_city,
                        state: this.address_state,
                        country: this.address_country,
                        postcode: this.address_postcode,
                        countryPhoneCode: this.selectedTelephoneCode.countryCode,
                        countryPhoneCodeNumber: this.selectedTelephoneCode.number,
                        premiereProfileBackgroundImageURL: this.background_image_url,
                        premiereProfileLogoImageURL: this.logo_image_url,
                        premiereProfileBio: this.bio,
                    });
                    this.snackbarText = "Changes saved successfully!";
                    this.snackbarTimeout = 5000;
                }
                catch(error) {
                    this.snackbarText = "Changes could not be saved. Please try again later.";
                    this.snackbarTimeout = 5000;
                    console.log("Error updating the business profile details" + error);
                }
            }
        }
    }
}
</script>
<style scoped>
.dz-image img {
    width: 100%;
    height: 100%;
}
.dropzone {
    height: 180px;
    border-radius: 4px;
}  
.backgroundImage {
  /* Full height */
  height: 100%;
  /* Center and scale the image properly */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.display-image-offset {
  top: -8.4%;
  position: relative;
}
</style>